module.exports = __webpack_public_path__ + "static/full_team-f43626c430a486f36584130d642e5bb4.jpg";